import React, { useEffect, useRef, useState } from 'react';
import Glide from '@glidejs/glide';
import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';
import { Link } from 'react-router-dom';
import useEventData from "../../Containers/eventv2/useEventData";


const EventsCarouselComponent = () => {
  const glideRef = useRef(null);

  const [eventsArrFromAPI] = useEventData();
  const [events_arr, setEvents_arr] = useState(null);

  useEffect(() => {
    if (eventsArrFromAPI.length) {
      setEvents_arr(eventsArrFromAPI);
      console.log(eventsArrFromAPI);
    }
  }, [eventsArrFromAPI]);

  function sendData({ id }) {
    // console.log(eventObj);
    localStorage.id = id;
  }

  useEffect(() => {
    if (events_arr && events_arr.length > 0) {
      const glide = new Glide(glideRef.current, {
        type: 'carousel',
        startAt: 0,
        perView: 3,
        autoplay: 3000, // Autoplay interval in milliseconds
      });

      glide.mount();

      return () => glide.destroy(); // Cleanup on unmount
    }
  }, [events_arr]);

  return (
    <>
      {events_arr && (
        <>
          
          <div ref={glideRef} className="glide">
            <div className="glide__track" data-glide-el="track">
              <ul className="glide__slides ">
                {events_arr.map(({ id, poster, name }, i) => (
                  <li className="glide__slide individual__event" key={i}>
                    <div className="event_image_wrapper">
                      <img className="eventImage" src={poster} alt={name} />
                      <Link
                        to="/EventSingle"
                        className="book_tickets_btn"
                        onClick={() => {
                          sendData({ id });
                        }}
                      >
                        Book Now
                      </Link>
                    </div>
                    <p className="eventName text-center">{name}</p>
                  </li>
                ))}
              </ul>
            </div>
            {/* <div className="glide__arrows" data-glide-el="controls">
              <button className="glide__arrow glide__arrow--left" data-glide-dir="<">prev</button>
              <button className="glide__arrow glide__arrow--right" data-glide-dir=">">next</button>
            </div> */}
          </div>
        </>
      )}
    </>
  );
};

export default EventsCarouselComponent;
